module.exports = __webpack_public_path__ + "static/media/headshot.ce4fa86c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/headshot.jpeg
// module id = 835
// module chunks = 0